

import { Box, CircularProgress, styled } from '@mui/material';
import { FC, useCallback } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Center from '../Center';
import Label from '../Label';
import { faChevronRight } from '@fortawesome/pro-duotone-svg-icons';


interface ISliderButtonProps {
    width?: string;
    height?: string;

    loading?: boolean;
    disabled?: boolean;

    onColor?: string;
    offColor?: string;

    value: boolean;
    onChange: (value: boolean) => Promise<void>;
}

const StyledLabel = styled(Label, { shouldForwardProp: props => props !== 'cWidth' && props !== 'cHeight' })<{ cWidth?: string, cHeight?: string }>(() => ({
    position: 'relative',
    width: '70px',
    height: '36px',
    background: 'green', 
    display: 'inline-block',
    borderRadius: '100px',
    boxShadow: 'inset 0px 2px 6px -2px rgba(0, 0, 0, 0.4)',

    "& > span": {
        position: 'absolute',
        left: '2px',
        top: '2px',
        bottom: 0,
        borderRadius: '50%',
        background: '#eee',
        boxShadow: '0px 2px 6px -2px rgba(0, 0, 0, 0.4)',
        width: '32px',
        height: '32px',
        transition: '0.4s left'
    },

    "& > input": {
        width: 0,
        visibility: 'hidden',
    },

    "& > input:checked + span": {
        left: 'calc(100% - 34px)'
    }
}));

const SliderButton: FC<ISliderButtonProps> = ({
    width,
    height,
    loading,
    disabled,
    onColor,
    offColor,
    value,
    onChange
}) => {

    const handleChange = useCallback(async (state: boolean) => {
        await onChange(state);
    }, [value, onChange]);

    return (
        <Box>
            <StyledLabel 
                cWidth={width} 
                cHeight={height} 
                sx={{ 
                    transition: 'all 0.4s', 
                    backgroundColor: disabled ? (value ? (onColor ? `${onColor}88` : '#4dab4622') : (offColor ?? '#aaa8')) : (value ? (onColor ?? '#4dab46') : (offColor ?? '#aaa'))
                }} 
            >
                <input 
                    type='checkbox' 
                    checked={value} 
                    onChange={(v) => handleChange(v.target.checked)} 
                    disabled={disabled} 
                />
                <Center component='span'>
                    {
                        loading && 
                        <CircularProgress 
                            sx={{ 
                                color: value ? (onColor ?? '#4dab46') : (offColor ?? '#aaa'),
                                position: 'absolute', 
                                maxHeight: '25px', 
                                maxWidth: '25px' 
                            }} 
                        />
                    }
                    <FontAwesomeIcon 
                        style={{
                            rotate: value ? '180deg' : '0deg',
                            color: '#999', 
                            fontWeight: '900',
                            transition: 'all 0.4s'
                        }} 
                        icon={faChevronRight} 
                    />
                </Center>
            </StyledLabel>
        </Box>
    )
}

export default SliderButton